import React, { Component } from "react";
import { Tabs } from "react-bootstrap";
import { Tab } from "react-bootstrap";
import { Col } from "reactstrap";
import { Card } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { Button } from "react-bootstrap";
import SimpleReactValidator from 'simple-react-validator';
import { connect } from "react-redux";
import { logincheck } from '../Userlogin/Userlogin'
import dateFormat from 'dateformat';
import firebase from "firebase/app";
import "firebase/storage"


class CustomerDetailsEdit extends Component {
    constructor(props) {   
        super(props);
        this.state = {
            customerId: this.props.location.data ? this.props.location.data : this.props.location.state.data ? this.props.location.state.data : 0,useremail:"", usermobile:"",
            companyName: "", contactNumber: "", doorNumber: "", streetName: "", area: "", city: "Chennai",
            landMark: "", pincode: "", email: "", tankCapacity: "", dailyNeed: "", corporateId: "","contactNumberRequired": false,
            companyType: "", roadSize: "", distanceBetweenGateAndSump: "", totalDissolvedSolids: "", userPhoneNumber: "",
            gstNumber: "", panNumber: "", oldDoorNumber: "", oldStreetName: "", oldArea: "", oldCity: "", gstLength: false,
            oldLat: "", oldLng: "", firstname: "", lastname: "", userid: "", alterNumber:"",contactalterRequired: false, profileImg: '',contactdocumenturl: '',
			editprofile: '', editcontact: '',
			errors: {
                gstLength: '', alt: ""

            }
        };
        this.nextPath = this.nextPath.bind(this);
        this.validator = new SimpleReactValidator({ messages: { currency: "Must be a valid number" }, autoForceUpdate: this, className: 'text-danger' });
        this.handleFormFields = this.handleFormFields.bind(this)
		this.handleChange = this.handleChange.bind(this);
		this.documenturlChange= this.documenturlChange.bind(this);
        this.validForm = this.validForm.bind(this);
    }

    nextPath(path, value) {
        this.props.history.push({ pathname: path, data: value });
    }
	handleChange = event => {
		this.setState({editprofile: event.target.files[0]}, function () { });
 
	} 
	documenturlChange = event => {
		this.setState({editcontact : event.target.files[0]}, function () { });
	}

    componentDidMount() {
        //console.log(this.props.location.data, 'data get set')
        //this.setState({ firstname: this.props.firstna, lastname: this.props.lastna})
		logincheck(this.props.userId, this.props.mobiledevice).then(({ data: data }) => {
			console.log(data.status_check)
			if(data.status_check === 0) {
				this.props.history.push({ pathname: `/Logout`, state: { userId : this.props.userId , logintoken: 2 } });
			}
		})
        const url = process.env.REACT_APP_NODE_ENV + "/api/corp-customer/getCCbyId/" + this.state.customerId
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            }
        }).then(
            response => { return response.json(); }
        ).then(data => {
            console.log(data)
            this.setState({
				
                firstname: data[0].user.userFirstName, lastname: data[0].user.userLastName, userid : data[0].user.id,  userPhoneNumber:data[0].user.userPhoneNumber, corporateId: data[0].corporateId, oldDoorNumber: data[0].doorNumber, oldStreetName: data[0].streetName,
                oldArea: data[0].area, oldCity: data[0].city,
                companyName: data[0].user.usercompanyName, contactNumber: data[0].contactNumber,
                doorNumber: data[0].doorNumber, streetName: data[0].streetName, area: data[0].area,
                city: data[0].city, landmark: data[0].landmark,
                pincode: data[0].pincode, email: data[0].email,
                tankCapacity: data[0].tankCapacity, dailyNeed: data[0].dailyNeed,
                companyType: data[0].companyType, roadSize: data[0].roadSize, distanceBetweenGateAndSump: data[0].distanceBetweenGateAndSump,
                totalDissolvedSolids: data[0].totalDissolvedSolids,
                gstNumber: data[0].gstNumber, panNumber: data[0].panNumber,  alterNumber:  data[0].alternateNumber,alt : data[0].alternateNumber,
				contactdocumenturl : data[0].contractdocumenturl,  profileimageurl :   data[0].profileimageurl
            }, () => this.fetchExistingAddress())
        })

    }

    fetchExistingAddress = () => {
        let address = this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city
        let postAddressData = {
            associateId: this.state.corporateId,
            fullAddress: address
        }
        fetch(process.env.REACT_APP_NODE_ENV + '/api/address/getAddressbyCustomerIdandFullAddress', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postAddressData)
        }).then(
            response => { return response.json(); }
        ).then(data => { console.log(data); this.setState({ oldLat: data.geolocationLat, oldLng: data.geolocationLng }) })
            .catch(error => console.log(error))
    }

    save = () => {
        if (this.validator.allValid() &&  (this.state.contactNumberRequired != 1 || this.state.contactNumberRequired === "" ) &&   (this.state.contactalterRequired != 1 || this.state.contactalterRequired === "" ) ) {
			
			var assing_profile=""
			if(this.state.editprofile != "" && this.state.editcontact != "") 
			{
				assing_profile="3"
			}
			else if(this.state.editprofile != "") {
				assing_profile="1"
			}
			else if(this.state.editcontact != "") {
				assing_profile="2"
			}
			if(assing_profile === "3")
				{
					var Image_name =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.editprofile.name;
					const uploadTask = firebase.storage().ref(`media/${Image_name}`).put(this.state.editprofile).then(snapshot => {
						var Image_name1 =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.editcontact.name;
						const uploadTask = firebase.storage().ref(`media/${Image_name1}`).put(this.state.editcontact).then(snapshots => {
							
							 const postCustData = {
								"companyName": this.state.companyName, "firstName":this.state.firstname, "lastName": this.state.lastname, "contactNumber": this.state.contactNumber,
								"doorNumber": this.state.doorNumber, "streetName": this.state.streetName,
								"area": this.state.area, "city": this.state.city, "pocUserId" : this.state.userid,
								"landmark": this.state.landmark, "pincode": this.state.pincode,
								"email": this.state.email, "tankCapacity": this.state.tankCapacity, "dailyNeed": this.state.dailyNeed,
								"companyType": this.state.companyType, "roadSize": this.state.roadSize, "distanceBetweenGateAndSump": this.state.distanceBetweenGateAndSump,
								"totalDissolvedSolids": this.state.totalDissolvedSolids, "profileimageurl" :  snapshot.metadata.downloadURLs[0]  ,"contractdocumenturl": snapshots.metadata.downloadURLs[0],
								"gstNumber": this.state.gstNumber, "panNumber": this.state.panNumber,"alternateNumber" : this.state.alterNumber,
								id: this.state.customerId
							};
							fetch(process.env.REACT_APP_NODE_ENV + '/api/corp-customer/updateCustomer', {
								method: 'PUT',
								headers: {
									'Content-Type': 'application/json',
									'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
								},
								body: JSON.stringify(postCustData)
							}).then(response => response.json())
								.then(data => {
									// if (this.state.oldDoorNumber !== this.state.doorNumber ||
										// this.state.oldStreetName !== this.state.streetName ||
										// this.state.oldArea !== this.state.area ||
										// this.state.oldCity !== this.state.city) {
										// this.createNewDriveryAddress(data[0].corporateId);
									// } else {
										this.nextPath("/corp-customer/customer-details", this.state.customerId)
									// }
								})
								.catch((err) => console.log(err))
							
							
						})
					})
				}
				else if(assing_profile === "1") {
					var Image_name =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.editprofile.name;
					const uploadTask = firebase.storage().ref(`media/${Image_name}`).put(this.state.editprofile).then(snapshot => {
						 const postCustData = {
						"companyName": this.state.companyName, "firstName":this.state.firstname, "lastName": this.state.lastname, "contactNumber": this.state.contactNumber,
						"doorNumber": this.state.doorNumber, "streetName": this.state.streetName,
						"area": this.state.area, "city": this.state.city, "pocUserId" : this.state.userid,
						"landmark": this.state.landmark, "pincode": this.state.pincode,
						"email": this.state.email, "tankCapacity": this.state.tankCapacity, "dailyNeed": this.state.dailyNeed,
						"companyType": this.state.companyType, "roadSize": this.state.roadSize, "distanceBetweenGateAndSump": this.state.distanceBetweenGateAndSump,
						"totalDissolvedSolids": this.state.totalDissolvedSolids, "profileimageurl" :  snapshot.metadata.downloadURLs[0],
						"gstNumber": this.state.gstNumber, "panNumber": this.state.panNumber,"alternateNumber" : this.state.alterNumber,
						id: this.state.customerId
					};
					fetch(process.env.REACT_APP_NODE_ENV + '/api/corp-customer/updateCustomer', {
						method: 'PUT',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
						},
						body: JSON.stringify(postCustData)
					}).then(response => response.json())
						.then(data => {
							// if (this.state.oldDoorNumber !== this.state.doorNumber ||
								// this.state.oldStreetName !== this.state.streetName ||
								// this.state.oldArea !== this.state.area ||
								// this.state.oldCity !== this.state.city) {
								// this.createNewDriveryAddress(data[0].corporateId);
							// } else {
								this.nextPath("/corp-customer/customer-details", this.state.customerId)
							// }
						})
						.catch((err) => console.log(err))
						
						
						
						
					})
				}
				else if(assing_profile === "2") {
					var Image_name1 =dateFormat(new Date(), 'yyyymmddhhmmss')+'_'+this.state.editcontact.name;
						const uploadTask = firebase.storage().ref(`media/${Image_name1}`).put(this.state.editcontact).then(snapshots => {
							 const postCustData = {
								"companyName": this.state.companyName, "firstName":this.state.firstname, "lastName": this.state.lastname, "contactNumber": this.state.contactNumber,
								"doorNumber": this.state.doorNumber, "streetName": this.state.streetName,
								"area": this.state.area, "city": this.state.city, "pocUserId" : this.state.userid,
								"landmark": this.state.landmark, "pincode": this.state.pincode,
								"email": this.state.email, "tankCapacity": this.state.tankCapacity, "dailyNeed": this.state.dailyNeed,
								"companyType": this.state.companyType, "roadSize": this.state.roadSize, "distanceBetweenGateAndSump": this.state.distanceBetweenGateAndSump,
								"totalDissolvedSolids": this.state.totalDissolvedSolids,"contractdocumenturl": snapshots.metadata.downloadURLs[0],
								"gstNumber": this.state.gstNumber, "panNumber": this.state.panNumber,"alternateNumber" : this.state.alterNumber,
								id: this.state.customerId
							};
							fetch(process.env.REACT_APP_NODE_ENV + '/api/corp-customer/updateCustomer', {
								method: 'PUT',
								headers: {
									'Content-Type': 'application/json',
									'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
								},
								body: JSON.stringify(postCustData)
							}).then(response => response.json())
								.then(data => {
									// if (this.state.oldDoorNumber !== this.state.doorNumber ||
										// this.state.oldStreetName !== this.state.streetName ||
										// this.state.oldArea !== this.state.area ||
										// this.state.oldCity !== this.state.city) {
										// this.createNewDriveryAddress(data[0].corporateId);
									// } else {
										this.nextPath("/corp-customer/customer-details", this.state.customerId)
									// }
								})
								.catch((err) => console.log(err))
							
						})
				}
				else {
					 const postCustData = {
						"companyName": this.state.companyName, "firstName":this.state.firstname, "lastName": this.state.lastname, "contactNumber": this.state.contactNumber,
						"doorNumber": this.state.doorNumber, "streetName": this.state.streetName,
						"area": this.state.area, "city": this.state.city, "pocUserId" : this.state.userid,
						"landmark": this.state.landmark, "pincode": this.state.pincode,
						"email": this.state.email, "tankCapacity": this.state.tankCapacity, "dailyNeed": this.state.dailyNeed,
						"companyType": this.state.companyType, "roadSize": this.state.roadSize, "distanceBetweenGateAndSump": this.state.distanceBetweenGateAndSump,
						"totalDissolvedSolids": this.state.totalDissolvedSolids,
						"gstNumber": this.state.gstNumber, "panNumber": this.state.panNumber,"alternateNumber" : this.state.alterNumber,
						id: this.state.customerId
					};
					fetch(process.env.REACT_APP_NODE_ENV + '/api/corp-customer/updateCustomer', {
						method: 'PUT',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
						},
						body: JSON.stringify(postCustData)
					}).then(response => response.json())
						.then(data => {
							// if (this.state.oldDoorNumber !== this.state.doorNumber ||
								// this.state.oldStreetName !== this.state.streetName ||
								// this.state.oldArea !== this.state.area ||
								// this.state.oldCity !== this.state.city) {
								// this.createNewDriveryAddress(data[0].corporateId);
							// } else {
								this.nextPath("/corp-customer/customer-details", this.state.customerId)
							// }
						})
						.catch((err) => console.log(err))
					
				}
			
			
           
				
				
        }
        else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    createNewDriveryAddress = (corporateId) => {
        fetch(
            "https://maps.googleapis.com/maps/api/geocode/json?address=" +
            this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city +
            "&key=AIzaSyCzYy4yif1EK2nk6S0cufJy2LKxXK8_i38&region=IN",
        )
            .then(data => data.json())
            .then(resp => {
                const { lat, lng } = resp.results[0].geometry.location;
                console.log(lat, lng, this.state.oldLat, this.state.oldLng)
                if (lat !== this.state.oldLat || lng !== this.state.oldLng) { this.createAddress(corporateId, lat, lng) }
                else { this.nextPath("/corp-customer/customer-details", this.state.customerId) }
                this.setState({ lat: lat, lng: lng })
            })
            .catch(err => console.log(err));
    }

    createAddress = (corporateId, lattitude, longitude) => {
        let postAddressData = {
            associateId: corporateId, defaultAddress: "No",
            fullAddress: this.state.doorNumber + ',' + this.state.streetName + ',' + this.state.area + ',' + this.state.city, geolocationLat: lattitude, geolocationLng: longitude, label: "Billing Address"
        };
        fetch(process.env.REACT_APP_NODE_ENV + '/api/address/createAddress', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            },
            body: JSON.stringify(postAddressData)
        }).then((response) => response.json())
            .then(data => {
                this.nextPath("/corp-customer/customer-details", this.state.customerId)
            })
    }

    leaveHandle = (event) => {
        event.preventDefault();
        this.validator.showMessageFor(event.target.name)
        const { id, value } = event.target;
        let errors = this.state.errors;

        switch (id) {
            case 'upassword':
                errors.password =
                    value.length < 8
                        ? 'Password must be 8 characters long!'
                        : '';
                if (value.length < 8) {
                    this.setState({ passLength: true });
                }
                else {
                    this.setState({ passLength: false });
                }
                break;
            case 'cgstNumber':
                errors.gstNumber =
                    value.length !== 15
                        ? 'GST Number must be 15 chracters long!'
                        : '';
                if (value.length === 15) {
                    this.setState({ gstLength: false });
                    var str = value;
                    var res = str.substring(2, 12);
                    this.setState({ panNumber: res })
                }
                else {
                    this.setState({ gstLength: true });
                }
                break;
            default:
                break;
        }

        this.setState({ errors, [id]: value }, () => {
            console.log(errors)
        })
    }

    handleFormFields = event => {
        this.validator.showMessageFor(event.target.name)
        switch (event.target.id) {
            case "ccompanyName":
                this.setState({ firstname: event.target.value })
                break;
            case "clastName":
                this.setState({ lastname: event.target.value })
                break;
            case "ccontactNumber":
                this.setState({ contactNumber: event.target.value })
				this.corporatecontactnumbervalid(event.target.value)
                break; 
				
			case "acontactNumber":
                this.setState({ alterNumber: event.target.value })
				this.corporatealtervalid(event.target.value)
                break; 
            case "cdoorNumber":
                this.setState({ doorNumber: event.target.value });
                break;
            case "cstreetName":
                this.setState({ streetName: event.target.value });
                break;
            case "carea":
                this.setState({ area: event.target.value });
                break;
            case "ccity":
                this.setState({ city: event.target.value })
                break;
            case "clandmark":
                this.setState({ landmark: event.target.value })
                break;
            case "cpincode":
                this.setState({ pincode: event.target.value })
                break;
            case "cemail":
                this.setState({ email: event.target.value.replace("+","") })
                break;
            case "ctankCapacity":
                this.setState({ tankCapacity: event.target.value })
                break;
            case "cdailyNeed":
                this.setState({ dailyNeed: event.target.value })
                break;
            case "ccompanyType":
                this.setState({ companyType: event.target.value })
                break;
            case "croadSize":
                this.setState({ roadSize: event.target.value })
                break;
            case "cdistanceBetweenGateAndSump":
                this.setState({ distanceBetweenGateAndSump: event.target.value })
                break;
            case "ctotalDissolvedSolids":
                this.setState({ totalDissolvedSolids: event.target.value })
                break;
            case "cgstNumber":
                this.setState({ gstNumber: event.target.value.toUpperCase() })
                if (event.target.value.length === 15) {
                    var str = event.target.value;
                    var res = str.substring(2, 12);
                    this.setState({ panNumber: res })
                }
                break;
            case "cpanNumber":
                this.setState({ panNumber: event.target.value })
                break;
            default: break;
        }
    }


	corporatecontactnumbervalid= (data) => {
		console.log(data)
		if(data != "" && (this.state.userPhoneNumber != data)) {
			if(data.length === 10) {
		
				const postCustData = {  "contactnumber" : data }
		  
		  
			  fetch(process.env.REACT_APP_NODE_ENV + '/api/corpcustomer/corpcontactnumber', {
				  method: 'POST',
				  headers: {
					'Content-Type': 'application/json',
					'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
				  },
				  body: JSON.stringify(postCustData)
				}).then((res) => res.json())
				  .then((data) => {
					 
					//console.log(data.error_token)
					if(data.error_token === 1) {
						this.setState({ contactNumberRequired: '1'})
					}
					else {
							this.setState({ contactNumberRequired: data.error_token })
					}
				   
				  })
				  .catch((err) => console.log(err))
			}
			else if(data.length < 9) {
				this.setState({ contactNumberRequired: 0 })
			}
			else if(data.length > 11) {
				this.setState({ contactNumberRequired: 0 })
			}
		} else {
			this.setState({ contactNumberRequired: 0 })
		}
	  
	  
  }
   corporatealtervalid = (data) =>   {
	   
	   
		if(data != "") {
			console.log(this.state.alt,  data)
			if(this.state.alt  != data) {
			
			if(data.length === 10) {
		
				const postCustData = {  "contactnumber" : data }
		  
		  
			  fetch(process.env.REACT_APP_NODE_ENV + '/api/corpcustomer/corpcontactnumber', {
				  method: 'POST',
				  headers: {
					'Content-Type': 'application/json',
					'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
				  },
				  body: JSON.stringify(postCustData)
				}).then((res) => res.json())
				  .then((data) => {
					 
					//console.log(data.error_token)
					if(data.error_token === 1) {
						this.setState({ contactalterRequired: '1'})
					}
					else {
							this.setState({ contactalterRequired: data.error_token })
					}
				   
				  })
				  .catch((err) => console.log(err))
			}
			else if(data.length < 9) {
				this.setState({ contactalterRequired: 0 })
			}
			else if(data.length > 11) {
				this.setState({ contactalterRequired: 0 })
			}
			}
			
		  }
		else  {
			this.setState({ contactalterRequired: 0 })
		}
	  
	  
  }
    validForm() {
        const { companyName, contactNumber, doorNumber, streetName, area, landmark, city, pincode, email, tankCapacity, dailyNeed,
            companyType, roadSize, distanceBetweenGateAndSump, totalDissolvedSolids, gstNumber, panNumber
        } = this.state;
        let validFormFlag = false;
        if (companyName === '') {
            this.setState({ companyNameRequired: true });
            return validFormFlag;
        }
        else if (contactNumber === '') {
            this.setState({ contactNumberRequired: true });
            return validFormFlag;
        }

        else if (doorNumber === '') {
            this.setState({ doorNumberRequired: true });
            return validFormFlag;
        }
        // else if (streetName === '') {
        //     this.setState({ streetNameRequired: true });
        //     return validFormFlag;
        // }
        else if (area === '') {
            this.setState({ areaRequired: true });
            return validFormFlag;
        }

        else if (landmark === '') {
            this.setState({ landmarkRequired: true });
            return validFormFlag;
        }
        else if (city === '') {
            this.setState({ cityRequired: true });
            return validFormFlag;
        }
        else if (pincode === '') {
            this.setState({ pincodeRequired: true });
            return validFormFlag;
        }
        else if (email === '') {
            this.setState({ emailRequired: true });
            return validFormFlag;
        }
        else if (tankCapacity === '') {
            this.setState({ tankCapacityRequired: true });
            return validFormFlag;
        }
        else if (dailyNeed === '') {
            this.setState({ dailyNeedRequired: true });
            return validFormFlag;
        }
        else if (companyType === '') {
            this.setState({ companyType: true });
            return validFormFlag;
        }
        else if (roadSize === '') {
            this.setState({ roadSize: true });
            return validFormFlag;
        }
        else if (distanceBetweenGateAndSump === '') {
            this.setState({ distanceBetweenGateAndSump: true });
            return validFormFlag;
        }
        else if (totalDissolvedSolids === '') {
            this.setState({ distanceBetweenGateAndSump: true });
            return validFormFlag;
        }
        else if (gstNumber === '') {
            this.setState({ gstNumberRequired: true });
            return validFormFlag;
        }
        else if (panNumber === '') {
            this.setState({ panNumberRequired: true });
            return validFormFlag;
        }
        else {
            return true;
        }
    }

    navigate = () => {
        if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User") {
            this.nextPath("/corp-customer/customer-details", this.state.customerId)
        } else if (this.props.userRole === "Corporate Customer") {
            this.nextPath("/")
        }
    }


    render() {

        let breadCrumbForUser = ""
        if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User") {
            breadCrumbForUser = (<Breadcrumb>
                <Breadcrumb.Item
                    onClick={() => this.nextPath("/corp-customer/customer-list")}
                >
                    Customer List
          </Breadcrumb.Item>
                <Breadcrumb.Item active>Customer Details</Breadcrumb.Item>
            </Breadcrumb>)
        } else {
            breadCrumbForUser = (<Breadcrumb>
                <Breadcrumb.Item active>Customer Details</Breadcrumb.Item>
            </Breadcrumb>)
        }

        return (<>
            {breadCrumbForUser}

            <div>
                <Card>
                    <Card.Body>
                        <Card.Title style={{ fontWeight: "bold", fontSize: "20px" }}>
							<div className="row">
								<div className="col-lg-8">
									 Customer Details - {this.state.companyName}
								</div>
								<div className="col-lg-4">
										 <Button className="float-right"
									variant="outline-danger"
									style={{ marginLeft: "10px", marginTop: "25px", width: "120px" }}
									onClick={this.navigate}>
									Cancel
								  </Button>&nbsp;&nbsp;&nbsp;
											<Button className="float-right"
												variant="outline-success"
												style={{ marginTop: "25px", width: "120px" }}
												onClick={() => this.save()}>
												Save
								  </Button>
								</div>
							</div>
                            
                           
                        </Card.Title>

                        <br />
                        <br />
                        <Tabs defaultActiveKey="basic-details">
                            <Tab eventKey="basic-details" title="Company Details">
							<div className="kt-heading kt-heading--md">Contact Details</div>
                                <Form>
                                    <Form.Row>
                                        <Form.Group className="col-lg-4" as={Col} controlId="ccompanyName">
                                            <Form.Label> First Name: *</Form.Label>
                                            <Form.Control
                                                type="text" name="firstName"
                                                value={this.state.firstname}
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('firstName', this.state.firstname, 'required')
                                            }

                                        </Form.Group>
                                        <Form.Group className="col-lg-4" as={Col} controlId="clastName">
                                            <Form.Label> Last Name: *</Form.Label>
                                            <Form.Control
                                                type="text" name="lastName"
                                                value={this.state.lastname}
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('lastName', this.state.lastname, 'required')
                                            }

                                        </Form.Group>
                                       <Form.Group as={Col} controlId="cemail" className="col-lg-4">
                                            <Form.Label>Email: *</Form.Label>
                                            <Form.Control
                                                type="text" name="email"
                                                value={this.state.email}
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('email', this.state.email, 'required|email')
                                            }
                                        </Form.Group>

                                        
                                    </Form.Row>
									
									<Form.Row>
									<Form.Group className="col-lg-4" as={Col} controlId="ccontactNumber">
                                            <Form.Label> Contact Number: </Form.Label>
                                            <Form.Control
                                                type="text" name="contactNumber"
                                                value={this.state.contactNumber}
                                                onChange={this.handleFormFields}
                                            >
                                            </Form.Control>
												{(this.state.contactNumberRequired != 0 ?
												<div class="text-danger">Contact Number Already Exists</div> : this.validator.message('Contact Number', this.state.contactNumber, 'phone|max:10') ) }
											
                                        </Form.Group>
                                      <Form.Group className="col-lg-4" as={Col} controlId="acontactNumber">
                                            <Form.Label> Alternate Number: </Form.Label>
                                            <Form.Control
                                                type="text" name="contactNumber"
                                                value={this.state.alterNumber}
                                                onChange={this.handleFormFields}
                                            >
                                            </Form.Control>
                                           {(this.state.contactalterRequired != 0 ?
												<div class="text-danger">Alternate Number Already Exists</div> : this.validator.message('Alternate Number', this.state.alterNumber, 'phone|max:10') ) }
											
                                        </Form.Group>
										
										 <div className="col-lg-3">
										  
											<label>Profile Picture</label>
											<input type="file" className="form-control"  placeholder="Upload your file"  
											
											    onChange={(e)=> { this.handleChange(e)  }}  onClick={(e)=> { e.target.value = null}}
											
											 / >
											 
										
										</div>
										<div className="col-log-2" style={{ margin:"20px 0px" }}>
											<img src={this.state.profileimageurl} width="80px" height = "40px" />
										</div>
									
									</Form.Row>
									<Form.Row>
										<div className="col-lg-4" >
											<label>Contract Document</label>
											<input type="file" className="form-control"  placeholder="Upload your file"  
											
											    onChange={(e)=> { this.documenturlChange(e)  }}  onClick={(e)=> { e.target.value = null}}
											
											 / >
										</div>
										<div className="col-log-2" style={{ margin:"22px 0px" }}>
											<div className="form-control">
												<a href={this.state.contactdocumenturl} download target="_blank">View document</a>
											</div>
										</div>
									</Form.Row>
                               <div className="kt-heading kt-heading--md">Company Details</div>
                                    <Form.Row>
									    <Form.Group className="col-lg-4" as={Col} controlId="ccompanyType" >
                                            <Form.Label>Company Type: *</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="companyType"
                                                value={this.state.companyType} disabled
                                                onChange={this.handleFormFields}
                                            >
                                                <option value="">Select Company Type</option>
                                                <option value="Mall">Mall</option>
                                                <option value="Institution">Institution</option>
                                                <option value="Industry">Industry</option>
                                                <option value="Hospital">Hospital</option>
                                                <option value="Hotel">Hotel</option>
                                                <option value="Corporate">Corporate</option>
                                                <option value="Goverment">Goverment</option>
                                            </Form.Control>
                                            {
                                                this.validator.message('companyType', this.state.companyType,
                                                    'required|alpha')
                                            }
                                        </Form.Group>
										<Form.Group as={Col} controlId="ctankCapacity">
                                            <Form.Label> Sump/Tank Capacity: *</Form.Label>
                                            <Form.Control
                                                type="text" name="tankCapacity"
                                                value={this.state.tankCapacity}
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('tankCapacity', this.state.tankCapacity, 'required|currency')
                                            }
                                        </Form.Group>
										<Form.Group as={Col} controlId="cdailyNeed">
                                            <Form.Label> Daily Need(in kl): *</Form.Label>
                                            <Form.Control
                                                type="text" name="dailyNeed"
                                                value={this.state.dailyNeed}
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {this.validator.message('dailyNeed', this.state.dailyNeed, 'required|currency')}
                                        </Form.Group>
                                        



                                        
                                        
                                    </Form.Row>

                                    <Form.Row>
									
                                        
                                        <Form.Group className="col-lg-4" as={Col} controlId="croadSize">
                                            <Form.Label>Road Size (in ft): </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="roadSize"
                                                value={this.state.roadSize}
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('roadSize', this.state.roadSize,
                                                    'integer,num')
                                            }
                                        </Form.Group>
                                        <Form.Group className="col-lg-4" as={Col} controlId="cdistanceBetweenGateAndSump">
                                            <Form.Label>Distance Between Gate & Sump(in ft): </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="distanceBetweenGateAndSump"
                                                value={this.state.distanceBetweenGateAndSump}
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('distanceBetweenGateAndSump', this.state.distanceBetweenGateAndSump,
                                                    'integer')
                                            }
                                        </Form.Group>
										<Form.Group className="col-lg-4" as={Col} controlId="ctotalDissolvedSolids">
                                            <Form.Label>Preferred TDS: *</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={this.state.totalDissolvedSolids}
                                                onChange={this.handleFormFields}
                                                name="totalDissolvedSolids"
                                            >
                                                <option value="">Select TDS</option>
                                                <option value="less than 300(Excellent)"> less than 300(Excellent) </option>
                                                <option value="300-500(Good)"> 300-500(Good) </option>
                                                <option value="600-900(Fair)"> 600-900(Fair) </option>
                                                <option value="900-1200(Poor)"> 900-1200(Poor)</option>
                                                <option value="Above 1200(Unacceptable)"> Above 1200(Unacceptable)   </option>
                                            </Form.Control>
                                            {
                                                this.validator.message('Select  Preferred tds', this.state.totalDissolvedSolids, 'required|string')
                                            }
                                        </Form.Group>
                                    </Form.Row>
                                </Form>
                            </Tab>


                            <Tab eventKey="address" title="Address">
                                <Form>
									<div className="kt-heading kt-heading--md">Address Details</div>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="cdoorNumber">
                                            <Form.Label> Door Number: *</Form.Label>
                                            <Form.Control
                                                type="text" name="doorNumber"
                                                value={this.state.doorNumber}
                                                onChange={this.handleFormFields}>

                                            </Form.Control>
                                            {
                                                this.validator.message('doorNumber', this.state.doorNumber, 'required')
                                            }

                                        </Form.Group>
                                        <Form.Group as={Col} controlId="cstreetName">
                                            <Form.Label> Street Name: *</Form.Label>
                                            <Form.Control
                                                type="text" name="streetName"
                                                value={this.state.streetName}
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('streetName', this.state.streetName, 'required')
                                            }
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="carea">
                                            <Form.Label> Area: *</Form.Label>
                                            <Form.Control
                                                type="text" name="area"
                                                value={this.state.area}
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('area', this.state.area, 'required|regex:^[a-zA-Z-. ]*$')
                                            }
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group as={Col} controlId="ccity">
                                            <Form.Label> City: *</Form.Label>
                                            <Form.Control
                                                as="select" name="city"
                                                value={this.state.city} disabled
                                                onChange={this.handleFormFields}
                                            >
                                                <option value="">Select Your City</option>
                                                <option value="Chennai">Chennai</option>
                                            </Form.Control>
                                            {
                                                this.validator.message('city', this.state.city, 'required|alpha_space')
                                            }
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="clandmark">
                                            <Form.Label> Landmark </Form.Label>
                                            <Form.Control
                                                type="text" name="landmark"
                                                value={this.state.landmark}
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('landmark', this.state.landmark, 'alpha_space')
                                            }

                                        </Form.Group>
                                        <Form.Group as={Col} controlId="cpincode">
                                            <Form.Label> Pincode: *</Form.Label>
                                            <Form.Control
                                                type="text" name="pincode"
                                                value={this.state.pincode}
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('pincode', this.state.pincode, 'required|integer|max:6|min:6')
                                            }
                                        </Form.Group>
                                    </Form.Row>
                                </Form>
                            </Tab>



                            <Tab eventKey="business" title="Business">
                                <Form>
								  <div className="kt-heading kt-heading--md">Business Details</div>
                                    <Form.Row>
                                        <Form.Group className="col-lg-4" as={Col} controlId="cgstNumber">
                                            <Form.Label> GST Number: *</Form.Label>
                                            <Form.Control 
                                                type="text" name="gstNumber"
                                                value={this.state.gstNumber}
                                                onChange={this.handleFormFields}
                                            ></Form.Control>
                                            {
                                                this.validator.message('gstNumber', this.state.gstNumber, 'required|alpha_num|min:15|max:15')
                                            }
                                            {/* {
												this.state.gstLength &&
												<span className="form-text text-muted"><div style={{ color: 'red' }}>GST Number should be 15 characters.</div></span>
											} */}
                                        </Form.Group>
                                        <Form.Group className="col-lg-4" as={Col} controlId="cpanNumber">
                                            <Form.Label> PAN Number: *</Form.Label>
                                            <Form.Control
                                                type="text" name="panNumber"
                                                value={this.state.panNumber}
                                                onChange={this.handleFormFields}
                                                disabled
                                            ></Form.Control>
                                            {
                                                this.validator.message('panNumber', this.state.panNumber, 'required|alpha_num')
                                            }
                                        </Form.Group>
                                    </Form.Row>
                                </Form>
                            </Tab>
                        </Tabs>
                    </Card.Body>
                </Card>
            </div>
        </>
        );
    }
}
const mapStateToProps = (state /*, ownProps*/) => {
    return {
        userRole: state.auth.user[0].userType,
        userId: state.auth.user[0].id,
        firstna: state.auth.user[0].userFirstName,
        lastna: state.auth.user[0].userLastName,
		mobiledevice: state.auth.user[0].mobiledeviceId,
    }
}

export default connect(
    mapStateToProps,
    null
)(CustomerDetailsEdit)